import React, { useCallback } from 'react';

const EmbedSVGIcon = ({ id, src }) => {
  const replace = useCallback((id) => {
    try {
      const nodes = Array.from(document.querySelectorAll(`#${id}_svgImage`));
      for (const node of nodes) {
        node.parentNode.replaceChild(node.contentDocument.documentElement, node);
      }
    } catch (e) {}
    return null;
  }, []);

  return (
    <object id={`${id}_svgImage`} onLoad={() => replace(id)} type="image/svg+xml" data={src}>
      <role value="img" />
    </object>
  );
};

export default EmbedSVGIcon;
